module.exports = __webpack_public_path__ + "img/depmap_svg_V16.5cf1964f.svg";